<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  watch: {
    // 라우트 변경 시 사이드 메뉴 닫기
    $route() {
      this.closeMenu();
    }
  }
})
export default class Header extends Vue {
  // 원본 $router.push (래핑 해제용)
  originalRouterPush = null;
  // 헤어 높이 관찰용 옵저버
  headerObserver = null;
  // 메뉴 열림/닫힘 상태
  isMenuOpen = false;
  // 현재 열려있는 드롭다운 ID
  openDropdownId = '';
  // 스크롤 관련
  lastScrollTop = 0;
  isHeaderVisible = true;
  // 메뉴 데이터 구조
  menuItems = [
    {
      id: 'davich-hearing',
      label: '다비치 히어링',
      children: [
        { id: 'greetings', label: '대표 인사말', path: '/about/greetings' },
        { id: 'brand-introduction', label: '브랜드 소개', path: '/about/brand-introduction' },
        { id: 'visual-identity', label: '비주얼 아이덴티티', path: '/about/visual-identity' },
        { id: 'customer-promise', label: '고객과의 약속', path: '/about/customer-promise' },
        { id: 'directions', label: '오시는 길', path: '/about/directions' }
      ]
    },
    {
      id: 'hearing-aid',
      label: '보청기',
      children: [
        { id: 'necessity', label: '보청기 필요성', path: '/hearing-aid/necessity' },
        { id: 'types', label: '보청기 종류', path: '/hearing-aid/types' },
        { id: 'brands', label: '보청기 브랜드', path: '/hearing-aid/brands' },
        { id: 'hearing-test', label: '청력 검사', path: '/hearing-aid/hearing-test' },
        { id: 'free-trial', label: '무료 체험', path: '/hearing-aid/free-trial' }
      ]
    },
    {
      id: 'price',
      label: '가격',
      children: [
        { id: 'hearing-aid-price', label: '보청기 가격', path: '/price/hearing-aid' },
        { id: 'as-cost', label: 'A/S 비용', path: '/price/as-cost' },
        { id: 'subsidy', label: '보청기 지원금', path: '/price/subsidy' },
        { id: 'insurance', label: '분실파손 보험', path: '/price/insurance' }
      ]
    },
    {
      id: 'reviews',
      label: '후기',
      children: [
        { id: 'test-review', label: '청력검사 후기', path: '/reviews/hearing-test' },
        { id: 'trial-review', label: '무료체험 후기', path: '/reviews/free-trial' },
        { id: 'usage-review', label: '실사용 후기', path: '/reviews/real-usage' }
      ]
    },
    {
      id: 'information',
      label: '정보',
      children: [
        { id: 'health-info', label: '건강 정보', path: '/information/health' },
        { id: 'hearing-aid-info', label: '보청기 정보', path: '/information/hearing-aid' },
        { id: 'guide-video', label: '안내 영상', path: '/information/videos' }
      ]
    },
    {
      id: 'customer-center',
      label: '고객센터',
      children: [
        { id: 'notice', label: '공지사항', path: '/customer/notice' },
        { id: 'product-registration', label: 'AS 안심 서비스 조회', path: '/customer/registration' },
        { id: 'consultation', label: '상담 예약', path: '/customer/consultation' },
        { id: 'find-store', label: '매장 찾기', path: '/customer/store-locator' }
      ]
    }
  ];

  updateHeaderHeight(){
    const el = this.$refs.header;
    if (!el) return;
    const height = el.offsetHeight;
    // 전역 CSS 변수로 등록 (다른 컴포넌트에서도 사용 가능)
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }
  // 메뉴 토글
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    // if (!this.isMenuOpen) {
    //   this.openDropdownId = '';
    // }
    // if (this.isMenuOpen) {
    //   document.body.style.overflow = 'hidden';
    // } else {
    //   document.body.style.overflow = '';
    // }
  }

  // 드롭다운 토글
  toggleDropdown(itemId) {
    this.openDropdownId = this.openDropdownId === itemId ? '' : itemId;
  }

  // 드롭다운 열림 상태 확인
  isDropdownOpen(itemId) {
    return this.openDropdownId === itemId;
  }

  // 페이지 이동
  navigateTo(path) {
    if (path) {
      this.closeMenu();
      this.$router.push(path).catch(() => {});
    }
  }

  // 메뉴 아이템 클릭 처리
  handleMenuItemClick(item) {
    if (item.children && item.children.length > 0) {
      this.toggleDropdown(item.id);
    } else if (item.path) {
      this.navigateTo(item.path);
    }
  }

  // 메뉴 닫기
  closeMenu() {
    this.isMenuOpen = false;
    this.openDropdownId = '';
    document.body.style.overflow = '';
  }

  // 매장 찾기 페이지로 이동
  goToStoreLocator() {
    this.closeMenu();
    this.$router.push('/customer/store-locator');
  }

  // 스크롤 감지 (헤더 숨김/표시)
  handleScroll() {
    // 메뉴가 열려있으면 헤더 숨김 처리 안함
    if (this.isMenuOpen) return;

    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // 스크롤이 최상단에 있으면 항상 표시
    if (currentScrollTop <= 0) {
      this.isHeaderVisible = true;
      this.lastScrollTop = currentScrollTop;
      return;
    }

    // 스크롤 방향 감지
    if (currentScrollTop > this.lastScrollTop && currentScrollTop > 100) {
      // 아래로 스크롤 & 100px 이상 스크롤 했을 때 헤더 숨김
      this.isHeaderVisible = false;
    } else {
      // 위로 스크롤 시 헤더 표시
      this.isHeaderVisible = true;
    }

    this.lastScrollTop = currentScrollTop;
  }

  // 컴포넌트 제거 시 정리
  beforeDestroy() {
    // body 스크롤 복구
    document.body.style.overflow = '';

    // ResizeObserver 정리
    if (this.headerObserver) {
      this.headerObserver.disconnect();
      this.headerObserver = null;
    }

    // 이벤트 리스너 제거
    window.removeEventListener('resize', this.updateHeaderHeight);
    window.removeEventListener('orientationchange', this.updateHeaderHeight);
    window.removeEventListener('scroll', this.handleScroll);

    // $router.push 원복
    if (this.originalRouterPush) {
      this.$router.push = this.originalRouterPush;
      this.originalRouterPush = null;
    }
  }

  mounted() {
    // 모든 이동 시도(router-link 포함)에서 사이드 메뉴 닫기
    this.originalRouterPush = this.$router.push.bind(this.$router);
    this.$router.push = (location, onComplete, onAbort) => {
      this.closeMenu();
      const result = this.originalRouterPush(location, onComplete, onAbort);
      // 같은 경로 재이동 시 NavigationDuplicated rejection 흡수
      if (result && typeof result.catch === 'function') {
        result.catch(() => {});
      }
      return result;
    };

    // 최초 1회 적용
    this.$nextTick(() => {
      this.updateHeaderHeight();

      // ResizeObserver로 헤더 높이 변화 감지
      if (window.ResizeObserver) {
        this.headerObserver = new ResizeObserver((entries) => {
          const entry = entries[0];
          const height = entry.target.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${height}px`);
        });

        const el = this.$refs.header;
        if (el) {
          this.headerObserver.observe(el);
        }
      }

      // 이벤트 리스너 등록
      window.addEventListener('resize', this.updateHeaderHeight);
      window.addEventListener('orientationchange', this.updateHeaderHeight);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    });
  }

}
</script>

<template>
  <div>
    <!-- 헤더 -->
    <header
      ref="header"
      :class="{ 'header-hidden': !isHeaderVisible }"
    >
      <button
          @click="toggleMenu"
          aria-label="메뉴 열기"
          class="menu-button"
      >
        <div class="icon-32px">
          <img src="@/assets/icons/icon-menu.svg"  alt="메뉴 아이콘">
        </div>
      </button>
      <div class="logo" @click="navigateTo('/')">
        <img src="@/assets/logos/logo-header.svg" width="187" alt="다비치 히어링 보청기 로고">
      </div>
      <button
          @click="goToStoreLocator"
          aria-label="매장 찾기"
          class="store-button"
      >
        <div class="icon-32px">
          <img src="@/assets/icons/icon-find-store.svg"  alt="다비치 히어링 매장 찾기 아이콘">
        </div>
      </button>
    </header>

    <!-- 사이드 메뉴 오버레이 -->
<!--    class="menu-overlay"-->
    <transition name="overlay">
      <div
          v-if="isMenuOpen"
          @click="closeMenu"
      ></div>
    </transition>

    <!-- 사이드 메뉴 -->
    <transition name="slide">
      <nav
          v-if="isMenuOpen"
          class="side-menu"
          @click.stop
      >
        <div class="menu-header">
          <button
              @click="closeMenu"
              class="close-button"
              aria-label="메뉴 닫기"
          >
            <div class="icon-32px">
              <img src="@/assets/icons/icon-close.svg" width="32" alt="메뉴 아이콘">
            </div>
          </button>
          <div class="logo" @click="navigateTo('/')">
            <img src="@/assets/logos/logo-header.svg" width="187" alt="다비치 히어링 보청기 로고">
          </div>
          <button
              @click="goToStoreLocator"
              aria-label="매장 찾기"
              class="store-button"
          >
            <div class="icon-32px">
              <img src="@/assets/icons/icon-find-store.svg" width="32" alt="다비치 히어링 매장 찾기 아이콘">
            </div>
          </button>
        </div>

        <div class="menu-content">
          <ul class="menu-list">
            <li
                v-for="item in menuItems"
                :key="item.id"
                class="menu-item"
            >
              <!-- 메뉴 아이템 -->
              <div
                  class="menu-item-header"
                  :class="{ 'has-children': item.children }"
                  @click="handleMenuItemClick(item)"
              >
                <span class="menu-label">{{ item.label }}</span>
                <span
                    v-if="item.children"
                    class="arrow-icon"
                    :class="{ 'rotated': isDropdownOpen(item.id) }"
                >
                  <img src="@/assets/icons/icon-header-arrow.svg" :alt="item.label + ' 메뉴 펼쳐보기'">
                </span>
              </div>

              <!-- 드롭다운 서브메뉴 -->
              <transition name="dropdown">
                <ul
                    v-if="item.children && isDropdownOpen(item.id)"
                    class="submenu"
                >
                  <li
                      v-for="child in item.children"
                      :key="child.id"
                      class="submenu-item"
                      @click="navigateTo(child.path)"
                  >
                    {{ child.label }}
                  </li>
                </ul>
              </transition>
            </li>
          </ul>
        </div>
      </nav>
    </transition>
  </div>
</template>

<style scoped lang="scss">
// 헤더 스타일
header {
  background-color: #fff;
  // PC 헤더 높이 80px → 64px (아이콘·로고 크기는 그대로, 위아래 여백만 줄임)
  padding: 16px 38px;
  max-width: 500px;
  @media (max-width: 768px) {
    max-width: 768px;

  }
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 1000;
  transition: transform 0.3s ease-in-out;
  transform: translateY(0);

  &.header-hidden {
    transform: translateY(-100%);
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }

    &:active {
      opacity: 0.5;
    }
  }

  .logo {
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }

    img {
      @media (max-width: 768px) {
        width: 148px;
        height: auto;
      }
    }
  }

  .icon-32px {
    img {
      @media (max-width: 768px) {
        width: 24px !important;
        height: auto;
      }
    }
  }

  @media (max-width: 768px) {
    // 모바일 헤더 높이 76px → 56px (버튼 터치 영역 44px는 유지, 아이콘 위치는 좌우 약 18px)
    padding: 6px 8px;

    button {
      min-width: 44px;
      min-height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0.05);
    }
  }
}

// 오버레이
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1100;
}

// 사이드 메뉴
.side-menu::-webkit-scrollbar{
  display:none;
}
.side-menu {
  //스크롤 가림
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-y: scroll;

  position: fixed;
  top: 0;
  width: 85%;
  max-width: 500px;
  height: 100%;
  background-color: #fff;
  z-index: 1200;
  overflow-y: auto;
  //box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);

  .menu-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // 본 헤더와 같은 높이(64px)
    padding: 16px 24px;
    border-bottom: 1px solid #e0e0e0;

    h2 {
      font-size: 18px;
      font-weight: 700;
      color: #1a73e8;
      margin: 0;
    }

    .close-button {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 24px;
      line-height: 1;
      color: #666;

      &:hover {
        opacity: 0.7;
      }
    }

    .logo {
      img {
        @media (max-width: 768px) {
          width: 148px;
          height: auto;
        }
      }
    }

    .icon-32px {
      img {
        @media (max-width: 768px) {
          width: 24px !important;
          height: auto;
        }
      }
    }

    // 모바일 메뉴 헤더 - 본 헤더와 같은 높이(56px)
    @media (max-width: 768px) {
      padding: 6px 8px;

      .close-button,
      .store-button {
        min-width: 44px;
        min-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .menu-content {
    padding: 32px 0;

    @media (max-width: 768px) {
      padding: 12px 0;
    }
  }

  .menu-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .menu-item {
    border-bottom: 1px solid #f0f0f0;
    .menu-item-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 24px;
      cursor: pointer;
      transition: background-color 0.2s;

      &:hover {
        background-color: #fefefe;
      }

      &:active {
        background-color: #e8e8e8;
      }

      .menu-label {
        font-family: font family/Font 2;
        font-weight: font weight/700;
        font-style: Bold;
        font-size: 24px;
        leading-trim: NONE;
        line-height: 60px;
        letter-spacing: 0%;
        vertical-align: middle;
        font-weight: 500;
        color: #222;

        @media (max-width: 768px) {
          font-size: 20px;
        }
      }

      .arrow-icon {
        font-size: 12px;
        color: #999;
        transition: transform 0.3s ease;

        &.rotated {
          transform: rotate(180deg);
        }

        @media (max-width: 768px) {
          font-size: 11px;
        }
      }

      // 모바일 1뎁스 - 좌우 20px 통일
      @media (max-width: 768px) {
        padding: 0 20px;
        min-height: 52px;

        .menu-label {
          line-height: 52px;
        }
      }
    }

    .submenu {
      list-style: none;
      padding: 0;
      margin: 0;
      background-color: #fafafa;

      .submenu-item {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 500;
        font-size: 22px;
        line-height: 63px;
        letter-spacing: -0.02em;
        vertical-align: middle;
        padding: 4px 24px 4px 48px;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover {
          background-color: #f5f5f5;
          color: #1a73e8;
        }

        &:active {
          background-color: #e0e0e0;
        }

        // 모바일 2뎁스 - 좌측 20px + 24px 인덴트
        @media (max-width: 768px) {
          padding: 14px 20px 14px 44px;
          font-size: 16px;
          line-height: 24px;
          min-height: 48px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

// 애니메이션
.overlay-enter-active,
.overlay-leave-active {
  transition: opacity 0.3s ease;
}

.overlay-enter,
.overlay-leave-to {
  opacity: 0;
}

// 슬라이드 애니메이션 미사용
// -active(전환) 없이 시작 상태(.slide-enter/.slide-leave-to 의 translateX(-100%))만 남아 있으면
// 열 때 왼쪽에 잔상이 보이므로 시작 상태를 제거함.
// 슬라이드를 되살릴 경우 .side-menu 의 left(현재 auto = 가운데 컨테이너 기준)도 함께 조정 필요.
//.slide-enter-active,
//.slide-leave-active {
//  transition: transform 0.3s ease;
//}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.dropdown-enter,
.dropdown-leave-to {
  max-height: 0;
  opacity: 0;
}

.dropdown-enter-to,
.dropdown-leave {
  max-height: 500px;
  opacity: 1;
}

// 반응형
@media (max-width: 768px) {
  .side-menu {
    width: 100%;
  }
}
</style>